import "../stylesheets/App.css";
import React from "react";
import { Route, Routes } from "react-router-dom";

import Intro from "./Intro";
import Login from "./Login";
import Register from "./Register";
import Home from "./Home";
import Stage from "./Stage";
import MyScore from "./MyScore";
import Ranking from "./Ranking";
import RankingFase from "./RankingFase";
import Error404 from "./Error404";
import ErrorAuth from "./ErrorAuth";
import ForgotPassword from "./ForgotPassword";
import ValidateEmail from "./ValidateEmail";
import ChangePassword from "./ChangePassword";
import TempPassword from "./TempPassword";
import QRGenerator from "./QRGenerator";
import Profile from "./Profile";
import DashboardAdmin from "./DashboardAdmin";
import DetailAdmin from "./DetailAdmin";
import Awards from "./Awards";
import Rules from "./Rules";
import PrivacyPolicy from "./PrivacyPolicy";

function App() {

  return (
    <Routes>
      <Route path="/Internos" element={<Intro category="2" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/awards" element={<Awards />} />
      <Route path="/my-score" element={<MyScore />} />
      <Route path="/ranking" element={<Ranking />} />
      <Route path="/stage-ranking" element={<RankingFase />} />
      <Route path="/" element={<Home />} />
      <Route path="/stage/:id" element={<Stage />} />
      <Route path="/error-auth" element={<ErrorAuth />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/rules" element={<Rules />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/validate-email" element={<ValidateEmail />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/temp-password" element={<TempPassword />} />
      <Route path="/qr-admin" element={<QRGenerator />} />
      <Route path="/admin" element={<DashboardAdmin />} />
      <Route path="/admin/detail/:idCategory/:idUser" element={<DetailAdmin />} />
      <Route path="*" element={<Error404 />} />
    </Routes>
  );
}

export default App;